import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "darlei-cookie-consent";

export default function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          role="dialog"
          aria-label="Aviso de cookies"
          data-testid="cookie-notice"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.5, delay: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-5 left-5 z-50 max-w-sm rounded-2xl border border-white/10 bg-[#161B22]/90 p-5 shadow-2xl backdrop-blur-xl sm:left-8"
        >
          <div className="flex items-start gap-3">
            <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" />
            <p className="text-sm leading-relaxed text-stone-300">
              Usamos cookies do Google Analytics para entender como o site é utilizado e
              melhorar sua experiência. Saiba mais na nossa{" "}
              <Link
                to="/privacidade"
                data-testid="cookie-notice-privacy-link"
                className="font-semibold text-amber-400 underline-offset-2 hover:underline"
              >
                Política de Privacidade
              </Link>
              .
            </p>
          </div>
          <button
            onClick={accept}
            data-testid="cookie-notice-accept"
            className="mt-4 w-full rounded-full bg-amber-400 px-5 py-2.5 text-xs font-bold uppercase tracking-wider text-[#0D1117] transition-[background-color,transform] duration-300 hover:scale-[1.02] hover:bg-amber-300"
          >
            Entendi
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
